import React from 'react';
import { Link } from 'react-router-dom';
import { getProviderSlug, getProviderSummary } from '../../utils/slots';
export function ProviderSection() {
  const summary = getProviderSummary();
  return <section id="providers" aria-labelledby="providers-title" className="mx-auto max-w-7xl scroll-mt-28 px-4 sm:px-6" data-id="element-150" data-mp="axzqf19lgcl">
      <div className="border-t border-line pt-16" data-id="element-151" data-mp="3rh970swvbdcd">
        <h2 id="providers-title" className="font-serif text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-152" data-mp="3ngfhxw7ovshw">
          Providers in de Top 30
        </h2>
        <p className="mt-2 max-w-2xl text-muted" data-id="element-153" data-mp="3ifrgeglu3t9f">
          Pragmatic Play domineert zowel in Nederland als in Nieuw-Zeeland, maar Play’n GO levert met Book of Dead de
          favoriet van veel Kiwi’s.
        </p>
        <ul className="mt-8 grid gap-x-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-154" data-mp="38kzlxlnjtmiv">
          {summary.map(p => <li key={p.name} className="flex items-baseline justify-between gap-4 border-b border-line py-4" data-id="element-155" data-mp="1bos8sc1nznit">
              <div className="min-w-0" data-id="element-156" data-mp="lmdu7i0kcf5y">
                <Link to={`/providers/${getProviderSlug(p.name)}`} className="font-semibold hover:underline" data-id="element-157" data-mp="llchl93wfkm4">
                  {p.name}
                </Link>
                <p className="truncate text-sm text-muted" data-id="element-158" data-mp="bo7un728bl49">
                  Hoogste: <Link to={`/slots/${p.top.slug}`} className="text-ink hover:underline" data-id="element-159" data-mp="bq10ik50q1b7">#{p.top.rank} {p.top.name}</Link>
                </p>
              </div>
              <span className="shrink-0 font-serif text-2xl font-semibold tabular-nums text-fern" data-id="element-160" data-mp="14clttq520nhe">{p.count}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}